import { type ICallNotification } from '@/types/INotification';
import { type ICallPayload } from '@/types/ICallPayload';
import { buildCallNotificationId } from './buildCallNotificationId';

/**
 * Создаёт уведомление о звонке из нормализованного payload. Идентификатор
 * завязан только на телефон, поэтому повторное событие по тому же номеру
 * обновляет существующую карточку, а не плодит вторую.
 *
 * @param payload - нормализованные данные звонка
 * @returns уведомление типа `call`
 */
export const createCallNotification = (
  payload: ICallPayload
): ICallNotification => ({
  id: buildCallNotificationId(payload.phone),
  type: 'call',
  createdAt: Date.now(),
  isRead: false,
  payload
});
